import { render, staticRenderFns } from "./assureur-detail.html?vue&type=template&id=b2cda0e0&scoped=true&external"
import script from "./assureur-detail.js?vue&type=script&lang=js&external"
export * from "./assureur-detail.js?vue&type=script&lang=js&external"
import style0 from "./assureur-detail.scss?vue&type=style&index=0&id=b2cda0e0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cda0e0",
  null
  
)

export default component.exports